import { FaDiscord, FaInstagram, FaXTwitter } from "react-icons/fa6"
import { trackEvent } from "../utils/tracking"

const socialLinks = [
  {
    name: "X",
    href: "https://x.com/Case_RTP",
    icon: FaXTwitter,
  },
  {
    name: "Instagram",
    href: "https://www.instagram.com/case_rtp/",
    icon: FaInstagram,
  },
  {
    name: "Discord",
    href: "https://discord.gg/s86hAj7gD4",
    icon: FaDiscord,
  },
]

export default function Giveaways() {
  return (
    <div className="container mx-auto px-4 py-10 sm:px-6 lg:px-8">
      <section className="mx-auto max-w-5xl rounded-3xl border border-[#2A2D31] bg-[#11151B]/80 p-6 shadow-[0_25px_80px_rgba(0,0,0,0.3)] backdrop-blur-md sm:p-8">
        <div className="mx-auto max-w-2xl py-8 text-center sm:py-12">
          <p className="text-sm uppercase tracking-[0.3em] text-[#FF6B00]/90">Stay Connected</p>
          <h1 className="mt-4 text-3xl font-bold font-display text-white sm:text-4xl">The Giveaway Has Ended</h1>
          <p className="mt-4 text-base leading-7 text-blue-100/80 sm:text-lg">
            Follow us on our socials to stay updated on future giveaways, announcements, and CaseRTP news.
          </p>

          <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
            {socialLinks.map(({ name, href, icon: Icon }) => (
              <a
                key={name}
                href={href}
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => trackEvent("SocialLinkClick", { platform: name.toLowerCase(), href })}
                className="inline-flex min-w-36 items-center justify-center gap-2 rounded-xl border border-[#2A2D31] bg-[#1A1D21]/70 px-5 py-3 font-medium text-blue-100 transition-colors hover:border-[#FF6B00]/70 hover:text-[#FF6B00]"
              >
                <Icon className="h-5 w-5" aria-hidden="true" />
                <span>{name}</span>
              </a>
            ))}
          </div>
        </div>
      </section>
    </div>
  )
}
